import { render, staticRenderFns } from "./WorkModeSwitch.vue?vue&type=template&id=18beb5fa&scoped=true"
import script from "./WorkModeSwitch.vue?vue&type=script&lang=js"
export * from "./WorkModeSwitch.vue?vue&type=script&lang=js"
import style0 from "./WorkModeSwitch.vue?vue&type=style&index=0&id=18beb5fa&prod&lang=scss&scoped=true"
import style1 from "./WorkModeSwitch.vue?vue&type=style&index=1&id=18beb5fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18beb5fa",
  null
  
)

export default component.exports